export class Vehicle {
  registration: string;
  make: string;
  model: string;
  year: string;
}
